import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {

  // API IP
  ip = environment.apiURL;

  // Listado API Rest
  APIURL = {
    currentUser: `${this.ip}/srvc/0`, // Información del usuario conectado
    login: `${this.ip}/srvc/1`, // Login del usuario
    logout: `${this.ip}/srvc/2`, // LoginOut del usuario
    serv3: `${this.ip}/srvc/3`, // Retorna documento json de \"rscr\"."
    serv4: `${this.ip}/srvc/4`, // Retorna un único identificador de objeto con el atributo seleccionado.
    serv5: `${this.ip}/srvc/5`, // Retorna prnt
    serv6: `${this.ip}/srvc/6`, // Retorna objeto
    serv8: `${this.ip}/srvc/8`, // Guarda objeto
    serv9: `${this.ip}/srvc/9`, // Elimina los atributos en el objeto, si no tiene atributos borra el objeto.
    serv10: `${this.ip}/srvc/10`, // Envía objeto a base de datos "Old".
    serv98: `${this.ip}/srvc/98`, // Obtener tasa de cambio.
    serv121: `${this.ip}/srvc/121`, // Programador de servicios automaticos (Principal,emte para envio de correos programados)
    serv129: `${this.ip}/srvc/129`, // Cambia estado On/Off inic
    serv130: `${this.ip}/srvc/130`, // Visualiza cantidades del estado de los objetos, dependiendo de la tabla, fecha y dias a restar.
    serv148: `${this.ip}/srvc/148`, // Estado.
    serv149: `${this.ip}/srvc/149`, // Estados según tabla tomando en cuenta unidad del usuario logeado.
    serv189: `${this.ip}/srvc/189`, // Cargar tabla por unidad de usuario logeado.
    serv194: `${this.ip}/srvc/194`, // Cargar Orden de Compra individualmente.
    serv201: `${this.ip}/srvc/201`, // Enganche al Soap de gestor documental.
    serv202: `${this.ip}/srvc/202`, // Enganche al SOAP Excel.
    serv203: `${this.ip}/srvc/203`, // Actualizar URL de acceso a DTE
    serv204: `${this.ip}/srvc/204`, // Retorna spreadsheets
    serv9995: `${this.ip}/srvc/9995`, // Envio de E-mail
    serv9997: `${this.ip}/srvc/9997`, // Bajar archivo.
    serv9998: `${this.ip}/srvc/9998`, // Subir archivo.
  };
}
